<template>
  <div>
    <div>Pontuação total da ADCT (Máximo de 24)</div>
    <div
      class="d-flex mt-4 flex-row"
      :class="{
        'flex-column gap-8': $vuetify.breakpoint.smAndDown,
        'gap-12': !$vuetify.breakpoint.smAndDown,
      }"
    >
      <div class="d-flex align-center mt-2 gap-2">
        <v-text-field
          :disabled="disabled"
          outlined
          dense
          :min="0"
          :max="24"
          type="number"
          v-if="form.adct.resultado_manual"
          v-model="form.adct.value"
          :rules="[$validation.minValue(0), $validation.maxValue(24)]"
          hide-spin-buttons
        />
        <span v-else :class="form.adct.value === '?' ? 'black--text text-h6' : `big-number ${adctSeverity.class}`">
          {{ form.adct.value ? form.adct.value : '?' }}
        </span>
        <span v-if="form.adct.value" class="ml-2" :class="adctSeverity.class">
          {{ adctSeverity.text }}
        </span>
      </div>
    </div>
    <v-switch
      :disabled="disabled"
      class="my-4"
      label="Aplicar resultado manualmente"
      v-model="form.adct.resultado_manual"
      hide-details
    />
    <div class="mb-4 mt-10">
      <send-attendance-survey survey-type="adct" :disabled="disabled"></send-attendance-survey>
    </div>
    <template v-if="!form.adct.resultado_manual">
      <div v-for="(question, index) in adctOptions.questions" :key="question.key">
        <div class="d-flex">
          <p class="list-number mb-0">{{ index + 1 }}.</p>
          <p class="question mb-0">{{ question.name }}</p>
        </div>
        <v-radio-group
          class="px-3"
          :disabled="disabled"
          v-model="form.adct.answers[question.key].value"
          :row="!$vuetify.breakpoint.smAndDown"
        >
          <v-radio
            v-for="option in question.options"
            :key="`${question.key}-${option.key}`"
            :value="option.value"
            :label="option.label"
          />
        </v-radio-group>
      </div>
    </template>
    <v-row>
      <v-col cols="12">
        <span class="reference">
          Referência: Atopic Dermatitis Control Tool_Versão 1, 06 Mar 2020 Sanofi Group e Regeneron Pharmaceuticals Inc.<br />
          Todos os direitos reservados. ADCT – Brazil/Portuguese ADCT_HCP information card_Flashcard -
          Brazil/Portuguese - Version of 06 Mar 2020 - Mapi. ID0085-TR-0083 / ADCT_HCP information
          card_Flashcard_AU1.0-MKTG_por-BR.doc
        </span>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { ADCT } from '@/components/AttendanceForm/atopicdermatitis/constants/adct'
import { createNamespacedHelpers } from 'vuex'
import SendAttendanceSurvey from '@/components/SendAttendanceSurvey.vue'

const {
  mapMutations: newAttendanceFormMutations,
  mapActions: newAttendanceFormActions,
  mapGetters: newAttendanceFormGetters,
} = createNamespacedHelpers('newAttendanceForm')

export default {
  name: 'AdctFormNode',
  components: { SendAttendanceSurvey },
  async created() {
    const extraAnswer = this.extraAnswers['adct']
    if (extraAnswer) {
      this.form = extraAnswer
      return
    }

    const surveyId = this.extraAnswers['survey']?.adct?.uuid
    if (surveyId) {
      const survey = await this.$api.getSurveyByUuid(surveyId)
      const keys = survey.data ? Object.keys(survey.data) : []
      for (const key of keys) {
        if (key === 'done' || key === 'startedAt') {
          continue
        }
        this.form.adct.answers[key].value = survey.data[key].value
      }
    }
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...newAttendanceFormMutations(['updateExtraAnswer']),
    ...newAttendanceFormActions(['getParameter', 'getExtraAnswer']),
  },
  computed: {
    ...newAttendanceFormGetters(['parameters', 'extraAnswers']),
    adctOptions() {
      return ADCT
    },
    computedAdct() {
      if (this.form.adct.resultado_manual) {
        return this.form.adct.value || 0
      }

      const answers = []
      Object.keys(this.form.adct.answers).forEach((answer) => {
        answers.push(this.form.adct.answers[answer].value)
      })
      return answers.reduce((partialSum, a) => partialSum + a, 0)
    },
    adctSeverity() {
      const adct = this.form.adct.answers
      if (isNaN(this.computedAdct)) {
        return { class: 'grey--text', text: '' }
      } else if (this.form.adct.resultado_manual && this.computedAdct <= 6) {
        return { class: 'cyan--text', text: 'Controlada' }
      } else if (this.form.adct.resultado_manual && this.computedAdct > 6) {
        return { class: 'orange--text', text: 'Não controlada' }
      } else if (
        this.computedAdct <= 6 &&
        adct.sintomas.value < 2 &&
        adct.coceira.value < 2 &&
        adct.eczema.value < 2 &&
        adct.sono.value < 1 &&
        adct.atividades_diarias.value < 2 &&
        adct.humor.value < 2
      ) {
        return { class: 'cyan--text', text: 'Controlada' }
      } else {
        return { class: 'orange--text', text: 'Não controlada' }
      }
    },
  },
  data() {
    return {
      form: {
        adct: {
          value: null,
          resultado_manual: false,
          answers: {
            sintomas: { value: null },
            coceira: { value: null },
            eczema: { value: null },
            sono: { value: null },
            atividades_diarias: { value: null },
            humor: { value: null },
          },
        },
      },
    }
  },
  watch: {
    computedAdct(newVal) {
      if (this.form.adct.resultado_manual) {
        return
      }
      this.form.adct.value = Number(newVal).toFixed(2)
    },
    form: {
      handler(value) {
        this.updateExtraAnswer({ name: 'adct', value })
      },
      deep: true,
    },
  },
}
</script>
<style scoped>
.reference {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
}

.big-number {
  font-weight: 500;
  color: green;
  font-size: 2.5rem;
}

.question {
  color: var(--v-neutral-lighten17);
  font-size: 16px;
  letter-spacing: 0.5px;
}

.list-number {
  letter-spacing: 0.15px;
  font-size: 16px;
  font-weight: 500;
  color: #000000;
  margin-right: 8px;
}
</style>
